import { connect } from 'react-redux'
import CadastroChargebackModal from './modal';

export default connect()(CadastroChargebackModal);
